import { useEffect } from "react";
import { DriverServerToClientEvents } from "../types";

import { webSocketClient } from "../services/WebSocketService";

export function useWebSocketEvent<
  TEventKey extends keyof DriverServerToClientEvents,
>(event: TEventKey, handler: DriverServerToClientEvents[TEventKey]) {
  const socket = webSocketClient.getSocket("drivers");

  useEffect(() => {
    if (!socket) return;
    socket.on(event, handler as any);

    return () => {
      if (!socket) return;
      socket.off(event, handler as any);
    };
  }, [event, handler, socket]);
}
